import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Register from "./pages/Register";
import './index.css';
import Home from "./pages/Home/Home";
import AaboutUs from "./pages/AaboutUs/About";
import ContactUs from "./pages/ContactUs/Contact";
import Services from "./pages/Services/Services";
import NotFound from "./pages/NotFound";
// import AuthForm from "./pages/Login/AuthForm";
import Dashboard from "./pages/Dashboard/Dashboard";
import { isTokenValid } from "./utils/auth";

const ProtectedRoute = ({ children }) => {
  const isLoggedIn = isTokenValid();
  return isLoggedIn ? children : <Navigate to="/" replace />;
};

function App() {
  return (
    <Router>
      <Header />
      <div className="min-h-screen">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AaboutUs />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/services" element={<Services />} />
          {/* <Route path="/login" element={<AuthForm />} /> */}
          <Route path="/register" element={<Register />} />
          <Route
            path="/dashboard" element={<ProtectedRoute> <Dashboard />
            </ProtectedRoute>
            }
          />
          <Route path="*" element={<NotFound />} />

        </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default App;
